import { History } from "history";
import queryStringParser from "query-string";
import { StayType } from "redmond/hotels-module/interfaces";
import { getIsTravelApp } from "@capone/common";
import { HotelShopStep } from "../../shop/reducer/state";

export interface IHotelParsedQuery {
  locationName: string;
  adultsCount?: number;
  children?: number[];
  roomsCount?: number;
  pets?: number;
  isTravelApp?: boolean;
  stayType?: StayType;
  shopStep?: HotelShopStep;
  showMap?: boolean;
}

export const parseQueryFromString = (
  queryString: string
): IHotelParsedQuery => {
  const {
    locationName,
    adultsCount,
    children,
    roomsCount,
    petsCount,
    stayType,
    shopStep,
    showMap,
  } = queryStringParser.parse(queryString);
  const { isTravelApp } = getIsTravelApp(queryString);

  const childrenArray = Array.isArray(children)
    ? children.map((age) => parseInt(age, 10))
    : [...(children ? [parseInt(children, 10)] : [])];

  const stayTypeQueryParamToStayType: Record<string, StayType> = {
    hotels: StayType.Hotels,
    homes: StayType.Homes,
    vacation_rentals: StayType.Homes,
    [StayType.Hotels]: StayType.Hotels,
    [StayType.Homes]: StayType.Homes,
  };

  const stayTypeResolved = stayTypeQueryParamToStayType[stayType as string];

  return {
    locationName: locationName as string,
    adultsCount: adultsCount ? parseInt(adultsCount as string, 10) : undefined,
    children: childrenArray,
    roomsCount: parseInt(roomsCount as string, 10),
    pets: parseInt(petsCount as string, 10),
    isTravelApp,
    stayType: stayTypeResolved,
    shopStep: shopStep as HotelShopStep,
    showMap: showMap === undefined ? undefined : showMap === "true",
  };
};

export const parseQueryString = (
  history: History
): IHotelParsedQuery | null => {
  const queryString = history?.location?.search || "";
  return queryString ? parseQueryFromString(queryString) : null;
};
